import {Box, Grid} from '@mui/material';
import React from 'react';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {useAccountContext} from '../../../contexts/AccountContext';
import GoalsSelect from '../../../components/Common/RecommendGoalsSelect';
import {BuilderPlanOptions} from './BuilderPlanOptions/BuilderPlanOptions';
import {BuilderWhatOptions} from './BuilderWhatOptions/BuilderWhatOptions';
import {BuilderWhenOptions} from './BuilderWhenOptions/BuilderWhenOptions';
import {BuilderWhoOptions} from './BuilderWhoOptions/BuilderWhoOptions';
import {builderFieldsType} from './builderFields';
import {BuilderSPPOptions} from './BuilderHowOptions/BuilderSPPOptions';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {HEADER_PLAN_LABELS} from './CreateBuilderHelpers';

export const CreateBuilderSPPDAHeader: React.FC = () => {
  const {values, isSubmitting} = useAutoForm<builderFieldsType>();
  const {account} = useAccountContext();
  const contacts = account?.contacts || [];
  const whatVisible = !!values.contact;
  const planActionVisible =
    whatVisible &&
    !!values.planAction &&
    values.planAction !== OVRecommendActionEnum.ACTION;

  return (
    <Box
      bgcolor="white"
      borderRadius="8px"
      paddingLeft={2.5}
      paddingRight={2.5}
      paddingTop={1.5}
      paddingBottom={1.5}
    >
      <Grid
        container
        direction="row"
        alignContent="flex-start"
        justifyContent="flex-start"
        spacing={5}
      >
        <Grid item>
          <BuilderSPPOptions isSubmitting={isSubmitting} />
        </Grid>
        <Grid item>
          <BuilderWhoOptions
            key={`${values.how}-${values.sppType}`} // component re-renders when dependency changes
            isSubmitting={isSubmitting}
            visible
            contacts={contacts}
          />
        </Grid>
        <Grid item>
          <BuilderWhatOptions
            key={`${values.contact}-${values.sppType}`} // component re-renders when dependencies change
            visible={whatVisible}
          />
        </Grid>
        {planActionVisible && (
          <Grid item>
            <BuilderPlanOptions
              // loading={potsLoading}
              key={`${values.contact}-${values.sppType}-${values.planAction}`} // component re-renders when dependencies change
              isSubmitting={isSubmitting}
            />
          </Grid>
        )}
        {values.planAction ? (
          <Grid item>
            <GoalsSelect
              key={values.contact} // component re-renders when dependency changes
            />
          </Grid>
        ) : null}
        {!!values.contact &&
        !!values.how &&
        !!values.planAction &&
        !!values.mainPlanType ? (
          <Grid item>
            <BuilderWhenOptions
              key={values.contact} // component re-renders when dependency changes
              visible={
                !!values.contact &&
                !!values.how &&
                !!values.planAction &&
                !!values.mainPlanType
              }
            />
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};
